import { Stack, Typography } from '@mui/material';

import InfoIcon from '../../../assets/icons/InfoIconBorderFill';
import colors from '../../../constants/colors';

interface ContentProps {
  testId: string;
  text: string;
}

const Content = ({ testId, text }: ContentProps) => (
  <Stack
    data-testid={`autoPayInfoBar-${testId}`}
    spacing={2}
    direction="row"
    sx={{
      alignItems: "center",
      px: 3,
      py: 1,
      backgroundColor: colors.csaaNeutral,
      borderRadius: 1
    }}>
    <InfoIcon />
    <Typography
      sx={{
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '16px',
        fontFamily: 'Cabin',
        fontKerning: 'normal',
      }}
    >
      {text}
    </Typography>
  </Stack>
);

interface AutoPayInfoBarProps {
  isIneligible?: boolean;
  paidByMortgagee?: boolean;
  addingCardDetails?: boolean;
}

const AutoPayInfoBar = ({
  paidByMortgagee,
  isIneligible,
  addingCardDetails,
}: AutoPayInfoBarProps) => {
  if (paidByMortgagee) {
    return <Content testId="paidByMortgagee" text="Paid by mortgage company" />;
  }

  if (isIneligible) {
    return (
      <Content
        testId="ineligible"
        text="AutoPay is unavailable for this policy"
      />
    );
  }

  if (addingCardDetails) {
    return (
      <Content
        testId="addingCardDetails"
        text="This new payment method will only be used for AutoPay and will not be saved to your wallet"
      />
    );
  }

  return null;
};

export default AutoPayInfoBar;
